import { useEffect } from 'react';
import i18n from '../../config/i18n';
import { useNotificationsStore } from '@/zustand/notificationsStore';

const useDeferredLoader = (controlState: boolean, id: string, options?: { delay?: number }) => {
  useEffect(() => {
    const delay = options?.delay || 500;
    let timeoutId: number | null = null;
    if (controlState) {
      timeoutId = setTimeout(
        () => useNotificationsStore.getState().notify.loading(i18n.t('Loading'), { id }),
        delay,
        id,
      );
      return () => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        useNotificationsStore.getState().notify.dismiss(id);
      };
    } else {
      useNotificationsStore.getState().notify.dismiss(id);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      useNotificationsStore.getState().notify.dismiss(id);
    };
  }, [controlState, id, options?.delay]);
};

export default useDeferredLoader;
